import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams, currentPage, pageUnit }) {
		try {
			const queryStr = objectToQueryString({
				strDt: searchParams.strDt.replaceAll('-', ''),
				period: searchParams.period,
				partNo: searchParams.partNo || searchParams.partNm,
				partGCd: searchParams.partGCd,
				tymaCd: searchParams.tymaCd,
				occuPlCd: searchParams.occuPlCd,
				currentPage,
				pageUnit
			});
			const response = await client.get(`${BASE_URL}/pqy/pcku/pprRptGrp/v1/lists${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getDetail({ searchParams, cofCd, currentPage, pageUnit }) {
		try {
			const queryStr = objectToQueryString({
				strDt: searchParams.strDt.replaceAll('-', ''),
				period: searchParams.period,
				partNo: searchParams.partNo || searchParams.partNm,
				partGCd: searchParams.partGCd,
				tymaCd: searchParams.tymaCd,
				occuPlCd: searchParams.occuPlCd,
				cofCd,
				currentPage: 1,
				pageUnit: 300
			});
			const response = await client.get(`${BASE_URL}/pqy/pcku/pprRptGrp/v1/details${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getGraph({ searchParams }) {
		try {
			const queryStr = objectToQueryString({
				strDt: searchParams.strDt.replaceAll('-', ''),
				period: searchParams.period,
				partNo: searchParams.partNo || searchParams.partNm,
				partGCd: searchParams.partGCd,
				tymaCd: searchParams.tymaCd,
				occuPlCd: searchParams.occuPlCd
			});
			const response = await client.get(`${BASE_URL}/pqy/pcku/pprRptGrp/v1/graphs${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
